import { render, staticRenderFns } from "./proof.vue?vue&type=template&id=331aa64b&scoped=true&"
import script from "./proof.vue?vue&type=script&lang=js&"
export * from "./proof.vue?vue&type=script&lang=js&"
import style0 from "./proof.vue?vue&type=style&index=0&id=331aa64b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331aa64b",
  null
  
)

export default component.exports